"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _GLUtils = _interopRequireDefault(require("./GLUtils"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

class GLFilter {
  constructor(fsSource, vsSource) {
    this.vsSource = vsSource ? vsSource : `
        attribute highp vec2 a_pos;
        attribute highp vec2 a_uv;
        
        varying highp vec2 v_uv;
        
        uniform bool u_invert;
        
        void main() {
            gl_Position = vec4(a_pos, 1.0, 1.0);
            if (u_invert) {
                gl_Position.y = -gl_Position.y;
            }
            v_uv = a_uv;
        }
        `;
    this.fsSource = fsSource;
  }

  initialize(gl) {
    this._viewWidth = 0;
    this._viewHeight = 0;
    this.width = 0;
    this.height = 0;
    this.textureCoords = [0.0, 1.0, 1.0, 1.0, 0.0, 0.0, 1.0, 0.0];
    this.vertexCoords = [-1.0, -1.0, 1.0, -1.0, -1.0, 1.0, 1.0, 1.0];
    this.program = _GLUtils.default.initShaderProgram(gl, this.vsSource, this.fsSource);
    this.attribLocations = this.initAttribLocations(gl, this.program);
    this.uniformLocations = this.initUniformLocations(gl, this.program);
    this.buffer = this.initBuffer(gl);
  }

  setViewSize(gl, width, height) {
    if (this._viewWidth !== width || this._viewHeight !== height) {
      this._viewWidth = width;
      this._viewHeight = height;
      gl.useProgram(this.program);
      this.onViewSizeChanged(gl, width, height);
    }
  }

  setSize(gl, width, height) {
    if (this.width !== width || this.height !== height) {
      this.width = width;
      this.height = height;
      gl.useProgram(this.program);
      const textureCoords = this.onSizeChanged(gl, this.textureCoords, width, height, this._viewWidth, this._viewHeight);
      const vertices = [];

      for (let i = 0; i < 4; ++i) {
        vertices.push(this.vertexCoords[2 * i]);
        vertices.push(this.vertexCoords[2 * i + 1]);
        vertices.push(textureCoords[2 * i]);
        vertices.push(textureCoords[2 * i + 1]);
      }

      gl.bindBuffer(gl.ARRAY_BUFFER, this.buffer);
      gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(vertices), gl.STATIC_DRAW);
    }
  }

  get outputTextureWidth() {
    return this.width;
  }

  get outputTextureHeight() {
    return this.height;
  }

  draw(gl, texture, flip, blend) {
    gl.viewport(0, 0, this._viewWidth, this._viewHeight);

    if (blend) {
      gl.enable(gl.BLEND);
      gl.blendFuncSeparate(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA, gl.ZERO, gl.ONE);
    } else {
      gl.clearColor(0.0, 0.0, 0.0, 1.0);
      gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
    }

    gl.useProgram(this.program);
    gl.bindBuffer(gl.ARRAY_BUFFER, this.buffer);
    gl.vertexAttribPointer(this.attribLocations.aPos, 2, gl.FLOAT, false, 4 * Float32Array.BYTES_PER_ELEMENT, 0);
    gl.enableVertexAttribArray(this.attribLocations.aPos);
    gl.vertexAttribPointer(this.attribLocations.aUV, 2, gl.FLOAT, false, 4 * Float32Array.BYTES_PER_ELEMENT, 2 * Float32Array.BYTES_PER_ELEMENT);
    gl.enableVertexAttribArray(this.attribLocations.aUV);
    this.willDraw(gl, this.uniformLocations, this.attribLocations, flip);
    gl.activeTexture(gl.TEXTURE0);
    gl.bindTexture(gl.TEXTURE_2D, texture);
    gl.uniform1i(this.uniformLocations.uSampler, 0);
    gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
    this.didDraw(gl, this.uniformLocations, this.attribLocations);
    gl.bindTexture(gl.TEXTURE_2D, null);

    if (blend) {
      gl.disable(gl.BLEND);
    }
  }

  onViewSizeChanged() {}

  onSizeChanged() {
    return this.textureCoords;
  }

  willDraw(gl, uniformLocations, attributeLocations, flip) {
    if (uniformLocations) {
      gl.uniform1i(uniformLocations.uFlip, flip ? 1 : 0);
    }
  }

  didDraw() {}

  initAttribLocations(gl, program) {
    return {
      aPos: gl.getAttribLocation(program, 'a_pos'),
      aUV: gl.getAttribLocation(program, 'a_uv')
    };
  }

  initUniformLocations(gl, program) {
    return {
      uSampler: gl.getUniformLocation(program, 't_tex'),
      uFlip: gl.getUniformLocation(program, 'u_invert')
    };
  }

  initBuffer(gl) {
    const buffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
    return buffer;
  }

}

exports.default = GLFilter;